/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import AttributeValues from "./AttributeValues";
import Open5eDocument from "./Open5eDocument";
import SavingThrows from "./SavingThrows";
import Speed from "./Speed";

export class MonsterOpen5e implements AttributeValues, SavingThrows, Open5eDocument {
    slug:                   string = "";
    desc:                   string = "";
    name:                   string = "Default Monster";
    size:                   string = "Medium";
    type:                   string = "Humanoid";
    subtype:                string = "";
    group:                  string = "";
    alignment:              string = "Neutral";
    armor_class:            number = 10;
    armor_desc:             string = "";
    hit_points:             number = 5;
    hit_dice:               string = "1d8"; /*16d10+64*/
    speed:                  Speed  = new Speed();
    strength:               number = 10;
    dexterity:              number = 10;
    constitution:           number = 10;
    intelligence:           number = 10;
    wisdom:                 number = 10;
    charisma:               number = 10;
    strength_save:          number | null = null;
    dexterity_save:         number | null = null;
    constitution_save:      number | null = null;
    intelligence_save:      number | null = null;
    wisdom_save:            number | null = null;
    charisma_save:          number | null = null;
    perception:             number = 0;
    skills:                 Map<string, number> = new Map();
    damage_vulnerabilities: string = "";
    damage_resistances:     string = "";
    damage_immunities:      string = "";
    condition_immunities:   string = "";
    senses:                 string = ""; /*blindsight 30 ft., darkvision 120 ft., passive Perception 19"*/
    languages:              string = "Common"; /*"Common, Draconic",*/
    challenge_rating:       string = "1";
    cr:                     number = 1.0;
    actions:                Ability[] = []; /*[{name, desc, attack_bonus, damage_dice, damage_bonus}, ...]*/
    bonus_actions:          Ability[] = []; /*null*/
    reactions:              Ability[] = [];
    legendary_desc:         string = "";
    legendary_actions:      Ability[] = [];
    special_abilities:      Ability[] = [];
    spell_list:             string[] = [];
    page_no:                number = 0;
    environments:           string[] = []; /*["Desert","Coastal"],*/
    img_main:               string | null = null;
    document__slug:         string = "";
    document__title:        string = "";
    document__license_url:  string = "";
    document__url:          string = "";
    useMm2024:              boolean = false;
}


export default MonsterOpen5e;